import { Agency } from './agencyService';
import apiClient from './apiClient';
import { Subscriber } from './subscriberService';

export interface Voucher {
  id: number;
  code: string;
  value: number;
  status: string;
  agency: Agency;
  subscriber?: Subscriber;
  expirationDate: Date;
}

export const voucherService = {
  getAll: () => 
    apiClient.get('/vouchers'),
    
  createForAgency: (packid) =>
    apiClient.post(`/v1/vouchers/new-voucher?packId=${packid}`),

  createVoucherViaBalance: (data: {
    packs: { packId: number; quantity: number;  }[];
    description: string;
  }) =>
    apiClient.post('/v1/vouchers/create/balance', data),

  createVoucherViaCard: (data: {
    packs: { packId: number; quantity: number;  }[];  
    description: string;
    paymentIntentId:string
  }) =>
    apiClient.post('/v1/vouchers/create/card', data),



  generateForAgency:(data: {
    packs: { packId: number; quantity: number;  }[];
    description: string;
  }) =>
    apiClient.post('/v1/vouchers/create/balance', data),

  getBySubscriber: (subscriberId: number) =>
    apiClient.get(`/v1/vouchers/subscriber/${subscriberId}`),

  getByAgency: (agencyId: number) =>
    apiClient.get(`/vouchers/agency/${agencyId}`),

  validate: (code: string) =>
    apiClient.post(`/vouchers/validate/${code}`),

  transfer: (voucherId: number, subscriberId: number) =>
    apiClient.post(`/vouchers/transfer`, { voucherId, subscriberId }),

  updateStatus: (id: number, status: string) =>
    apiClient.patch(`/vouchers/${id}/status`, { status })
};